
export function Unauthorized() {

  return (
      <h4 className="absolute bottom-1/2 left-2/5 text-red-800 bg-red-100 rounded-lg py-6 px-6 w-md text-center text-xl ">Unauthorized</h4> 
  );

}